import { log } from './loggingService';

const API_BASE_URL = 'https://deadapi.techysumo.it/techyshop';
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Recupera le chiamate Apache dalla tabella _docalls con paginazione e filtri.
 * @param {Object} params - Parametri per la ricerca (limit, offset, filters, orderBy, order).
 * @returns {Promise<{success: boolean, details: Array, total: number, error?: string}>}
 */
export const searchDocalls = async (params = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/searchDocalls`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': API_KEY,
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`Errore API: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();

    if (result.result) {
      return {
        success: true,
        details: result.details || [],
        total: result.total || 0, // Assumiamo che l'API restituisca il totale dei record
      };
    } else {
      return {
        success: false,
        details: [],
        total: 0,
        error: result.text || 'Errore durante il recupero dei dati',
      };
    }
  } catch (error) {
    log("Errore durante il recupero di _docalls:", 'ERROR', error);
    return { success: false, details: [], total: 0, error: error.message };
  }
};
